import React from 'react';
import { WttpQuestionnaireCard } from './card';
import { WttpQuestionnaireResponsesData } from '../types';
import { Pagination, PaginationCounter, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';

type WttpQuestionnaireCardProps = {
  data: WttpQuestionnaireResponsesData[];
  totalCount: number;
  rowsPerPage: number;
  page: number;
  onPageChange: (page: number) => void;
};

export const WttpQuestionnaireCardList = ({
  data,
  totalCount,
  rowsPerPage,
  page,
  onPageChange,
}: WttpQuestionnaireCardProps) => {
  const { t } = useTranslation();
  const showPagination = totalCount > rowsPerPage;

  if (!data.length) {
    return (
      <Typography className="flex text-center mt-8 mx-4">
        {t('wttp.questionnaire-response.list.empty-list')}
      </Typography>
    );
  }

  return (
    <div className="mt-3">
      {showPagination && (
        <div className="mb-3 flex justify-between items-center">
          <PaginationCounter
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
          />
          <Pagination
            page={page}
            count={totalCount}
            rowsPerPage={rowsPerPage}
            onChange={onPageChange}
          />
        </div>
      )}
      <div className="flex gap-2 flex-col">
        {data.map((questionnaireResponse) => (
          <WttpQuestionnaireCard
            questionnaireResponse={questionnaireResponse}
            key={questionnaireResponse.id}
          />
        ))}
      </div>
      {showPagination && (
        <div className="mt-3 flex justify-end">
          <Pagination
            page={page}
            count={totalCount}
            rowsPerPage={rowsPerPage}
            onChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};
